import { useEffect, type ReactNode } from 'react';
import { Gradient, Overlay, OverlayBody } from './FullScreenOverlay.styles';

interface DropdownOverlayProps {
  header?: ReactNode;
  children: ReactNode;
  onlyMobile?: boolean;
  padding?: string;
  background?: string;
  gradient?: boolean;
  scroll?: boolean;
  removePadding?: boolean;
  openCallback?: () => void;
  closeCallback?: () => void;
}

function FullScreenOverlay(props: DropdownOverlayProps) {
  const {
    header,
    children,
    padding,
    background,
    gradient,
    removePadding,
    scroll = true,
    openCallback,
    closeCallback,
  } = props;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    if (openCallback) openCallback();

    return () => {
      document.body.style.overflow = 'unset';
      if (closeCallback) closeCallback();
    };
  }, []);

  return (
    <Overlay background={background} removePadding={removePadding}>
      {gradient && <Gradient />}
      {header}
      <OverlayBody padding={padding} scroll={scroll}>
        {children}
      </OverlayBody>
    </Overlay>
  );
}

export default FullScreenOverlay;
